import { Component, Vue, Watch } from 'vue-property-decorator';
import { PropOptions } from 'vue';
import { IADField } from '@/shared/model/ad-field.model';
import { hasPrecision } from '@/utils/validate';

const FsInputNumberProps = Vue.extend({
  props: {
    disabled: Boolean,
    fieldMeta: Object,

    rows: <PropOptions>{
      type: Number,
      default: () => {
        return 1;
      },
    },

    value: String,
  },
});

@Component({
  methods: {
    hasPrecision,
  },
})
export default class FsInputNumber extends FsInputNumberProps {
  number: string = null;

  get maxValue() {
    const meta = this.fieldMeta as IADField;
    const overrideColumn = meta.maxValue !== void 0 && meta.maxValue !== null;
    const max = overrideColumn ? meta.maxValue : meta.adColumn?.maxValue;
    return max === void 0 || max === null ? Infinity : max;
  }

  get minValue() {
    const meta = this.fieldMeta as IADField;
    const overrideColumn = meta.minValue !== void 0 && meta.minValue !== null;
    const min = overrideColumn ? meta.minValue : meta.adColumn?.minValue;
    return min === void 0 || min === null ? -Infinity : min;
  }

  get precision() {
    return hasPrecision(this.fieldMeta) ? 2 : 0;
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.number = value;
  }

  onChanged(value: string) {
    this.$emit('change', value);
  }

  onInput(value: string) {
    this.$emit('input', value);
  }

  created() {
    this.number = this.value;
  }

  hasPrecision!: (field: IADField) => boolean;
}
